import styled from "styled-components";
import { primaryColors, secondaryColors } from "../constatnts";

export const Title = styled.h1`
  color: ${primaryColors[0]};
  line-height: 2rem;
  font-size: 1.3em!important;
`;
export const SubTitle = styled.p`
  color: #4d4d4d;
`;

export const SectionTitle = styled.h1`
font-size: 1.3em!important;
color: ${secondaryColors[0]};
`;

export const Spacer = styled.div`
  width: 30px;
  height: 30px;
`;